import React, {Fragment, useContext, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Chip,
  Divider,
  LinearProgress,
  linearProgressClasses,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import {styled} from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import {MenuContext} from "../../contexts/menuContext";
import premium from "../../assets/images/premium.svg";

import dot from "../../assets/images/dot.svg";
import add from "../../assets/images/add.svg";
import profileImg from "../../assets/images/profileImg.svg";
import {
  BubbleChartIcon,
  DashboardIcon,
  HomeIcon,
  LineChartIcon,
  LocalPoliceIcon,
  MapIcon,
  MoneyIcon,
  NewsIcon,
  PersonSearchIcon,
  SearchIcon,
} from "../../assets/svgFile.jsx";
import "./sidebar.css";
import {useVarAuth} from "../../graphql/graphql/auth/defaults";

const drawerWidth = 246;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({theme, open}) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#606060" : "#308fe8",
  },
}));

const topMenu = [
  // {name: "Home", isAccordian: false, menuIcon: <HomeIcon />, chip: "10"},
  {
    name: "Dashboard",
    isAccordian: false,
    menuIcon: <DashboardIcon />,
    chip: "",
    route: "/dashboard",
  },
  // {
  //   name: "Marketcap rank",
  //   isAccordian: true,
  //   menuIcon: <BubbleChartIcon />,
  //   chip: "",
  //   accordianMenu: [{name: "USA Marketcap", icon: <BubbleChartIcon />}],
  // },
  // {
  //   name: "Option flow",
  //   isAccordian: false,
  //   menuIcon: <LineChartIcon />,
  //   chip: "",
  // },
  // {
  //   name: "Insider trading",
  //   isAccordian: false,
  //   menuIcon: <LocalPoliceIcon />,
  //   chip: "",
  // },
];

const bottomMenu = [
  // {
  //   name: "Senate tracker",
  //   isAccordian: true,
  //   menuIcon: <PersonSearchIcon />,
  //   chip: "",
  //   accordianMenu: [{name: "World Marketcap", icon: <PersonSearchIcon />}],
  // },
  // {
  //   name: "News",
  //   isAccordian: false,
  //   menuIcon: <NewsIcon />,
  //   chip: "",
  // },
  // {
  //   name: "Screener",
  //   isAccordian: false,
  //   menuIcon: <SearchIcon />,
  //   chip: "",
  // },
  // {
  //   name: "Portfolio track",
  //   isAccordian: false,
  //   menuIcon: <MoneyIcon />,
  //   chip: "",
  // },
  // {
  //   name: "Heat maps",
  //   isAccordian: false,
  //   menuIcon: <MapIcon />,
  //   chip: "",
  // },
];

const Sidebar = () => {
  const {open, isSmall} = useContext(MenuContext);
  const {user={}} = useVarAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [closeNotification, setCloseNotification] = useState(true);
  const [currentRoute] = useState(location?.pathname ?? "/");

  const renderMenu = (menu, index) => (
    <Fragment key={index}>
      {!menu.isAccordian ? (
        <ListItem
          disablePadding
          className={menu?.route === currentRoute ? "activeMenu" : ""}
          onClick={() => {
            navigate(menu?.route);
          }}
        >
          <ListItemButton sx={{justifyContent: open ? "initial" : "center"}}>
            <ListItemIcon sx={{mr: open ? 2 : "auto"}}>{menu?.menuIcon}</ListItemIcon>
            <ListItemText primary={menu?.name} sx={{opacity: open ? 1 : 0}} />
            {menu?.chip !== "" && (
              <Chip avatar={<Avatar alt="dot" src={dot} />} label={menu?.chip} sx={{display: open ? "" : "none"}} />
            )}
          </ListItemButton>
        </ListItem>
      ) : (
        <ListItem disablePadding className={menu?.route === currentRoute ? "activeMenu activeAccordion" : ""}>
          <Accordion>
            <AccordionSummary
              expandIcon={open ? <ExpandMoreIcon /> : ""}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <ListItemIcon sx={{mr: open ? 2 : "auto"}}>{menu?.menuIcon}</ListItemIcon>
              <Typography sx={{display: open ? "" : "none"}}>{menu?.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {menu?.accordianMenu?.map((menu, key) => (
                <ListItemButton sx={{justifyContent: open ? "initial" : "center"}} key={key}>
                  <ListItemText primary={menu?.name} sx={{opacity: open ? 1 : 0}} />
                </ListItemButton>
              ))}
            </AccordionDetails>
          </Accordion>
        </ListItem>
      )}
    </Fragment>
  );

  return (
    <Box className={`sidebarMain ${open ? "" : "closeSidebar"}`}>
      <Drawer variant="permanent" open={open} className="sidebar-drawer">
        <Box>
          {isSmall && (
            <>
              <Box className="topLeftPanel" display="flex" alignItems="center" paddingX="16px" marginBottom={"8px"}>
                <img src={premium} alt="premium" className="imgPremium" />
                <Typography variant="body1" sx={{ml: 1}}>
                  buythedip.com
                </Typography>
              </Box>
              <Divider sx={{margin: "0 !important"}} />
            </>
          )}
          <List>{topMenu?.map((menu, index) => renderMenu(menu, index))}</List>

          {/* <Divider sx={{margin: "0 !important"}} /> */}
          {/* <List>{bottomMenu?.map((menu, index) => renderMenu(menu, index))}</List> */}
        </Box>
        <Box
          sx={{
            marginBottom: isSmall ? "-20px" : "0px",
          }}
        >
          {/* {closeNotification && (
            <Box className="freetrial" sx={{display: open ? "" : "none"}}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h6">FREE trial reminder</Typography>
                <CloseIcon onClick={() => setCloseNotification(false)} />
              </Box>
              <Typography>
                6 days left then you will be charged $59.99. If you're a student, you can get more time.
              </Typography>
              <BorderLinearProgress variant="determinate" value={50} />
              <Box display="flex" alignItems="center">
                <Typography>I'm a student</Typography>
                <Link to="">Go pro</Link>
              </Box>
            </Box>
          )} */}
          <Box
            // m={3}
            className="sidebarFooter"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexDirection={open ? "row" : "column-reverse"}
            gap={open ? "0px" : "18px"}
            sx={{
              padding: "10px 12px",
              background: "linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #0F0F0F",
              margin: isSmall ? "0px !important" : "",
            }}
          >
            {/* <LightModeOutlinedIcon /> */}
            <Box display="flex" alignItems="center" gap="8px">
              <img
                src={user.avatar || profileImg}
                alt="profile_pic"
                style={{borderRadius: "50%", width: "32px", height: "32px"}}
              />
              {open && (
                <Typography variant="body2" fontWeight={700} color="rgba(255, 255, 255, 0.87)">
                  {user.name}
                </Typography>
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              flexDirection={open ? "row" : "column"}
              gap={open ? "12px" : "18px"}
            >
              <img src={add} alt="add_user" />
              <SettingsIcon
                className={currentRoute.includes("/settings") ? "activeMenu" : ""}
                onClick={() => navigate("/settings")}
                sx={{
                  color: "#878787 !important",
                  background: "none !important",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Sidebar;
